import { render, staticRenderFns } from "./AddWorkflow.vue?vue&type=template&id=66b59dbe&scoped=true&"
import script from "./AddWorkflow.vue?vue&type=script&lang=js&"
export * from "./AddWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./AddWorkflow.vue?vue&type=style&index=0&id=66b59dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b59dbe",
  null
  
)

component.options.__file = "AddWorkflow.vue"
export default component.exports